import type { IUISupplier } from '@bridebook/toolbox/src/types';
import type { IDeps } from '../../../types';
import { EnquiriesActionTypes } from '../../action-types';
import { EnquiriesAnalyticsActionTypes } from '../action-types';
import { EnquiryIntents } from '@bridebook/web/lib/enquiries/intent';
import { getFailedToSendEnquiryReason } from '@bridebook/web/lib/enquiries/utils/enquiry-send-analytics';

interface IEnquiriesServerSideTrackStartArgs {
  supplier?: IUISupplier;
  event: string;
  infoProps?: Record<string, any>;
}

// LIVE-27666 — Clean up if LIVE-27666 is to be removed!
type FailedToSendEnquiryAnalyticsOptions = {
  /** LIVE-27666 variant only — maps errors to stable `failedToSendEnquiryReason` codes. */
  normalizeFailedReason?: boolean;
};

export const failedToSendEnquiryAnalytics =
  (error: Error, supplier?: IUISupplier, options?: FailedToSendEnquiryAnalyticsOptions) =>
  ({ dispatch }: IDeps) => {
    const errorMessage = options?.normalizeFailedReason
      ? getFailedToSendEnquiryReason(error)
      : error.message;

    dispatch(
      enquiriesServerSideTrackStart({
        event: 'Failed to send enquiry',
        infoProps: { errorMessage },
        supplier,
      }),
    );

    return {
      type: EnquiriesAnalyticsActionTypes.FAILED_TO_SEND_ENQUIRY_ANALYTICS,
    };
  };

export const failedToConfirmDetailsAnalytics =
  (error: Error) =>
  ({ dispatch }: IDeps) => {
    dispatch(
      enquiriesServerSideTrackStart({
        event: 'Failed to confirm details',
        infoProps: {
          errorMessage: error.message,
        },
      }),
    );

    return {
      type: EnquiriesAnalyticsActionTypes.FAILED_TO_CONFIRM_DETAILS_ANALYTICS,
    };
  };

export const confirmedEnquiryDetailsAnalytics =
  (enquiryDetailsConfirmLocation: string) =>
  ({ dispatch }: IDeps) => {
    dispatch(
      enquiriesServerSideTrackStart({
        event: 'Confirmed enquiry details',
        infoProps: {
          enquiryDetailsConfirmLocation,
        },
      }),
    );

    return {
      type: EnquiriesAnalyticsActionTypes.CONFIRMED_ENQUIRY_DETAILS_ANALYTICS,
    };
  };

export const enquiriesServerSideTrackStart = (payload: IEnquiriesServerSideTrackStartArgs) => ({
  type: EnquiriesAnalyticsActionTypes.ENQUIRIES_SERVER_SIDE_TRACK,
  payload,
});

export const sendEnquirySuccessAnalytics = ({
  contactedSupplier,
  contactLocation,
  enquiryId,
  isFromExternalPage,
  contactType,
  contactMethod,
  linkedSupplierName,
  linkedSupplierId,
  message,
  intents,
  defaultIntentsSelected,
  defaultMessageTyped,
}: {
  contactedSupplier: IUISupplier;
  contactLocation?: string;
  enquiryId: string;
  isFromExternalPage?: boolean;
  contactType?: string;
  contactMethod?: string;
  linkedSupplierName?: string;
  linkedSupplierId?: string;
  message?: string;
  intents: EnquiryIntents;
  defaultIntentsSelected?: boolean;
  defaultMessageTyped?: boolean;
}) => ({
  type: EnquiriesActionTypes.SEND_ENQUIRY_SUCCESS_ANALYTICS,
  payload: {
    contactedSupplier,
    contactLocation,
    id: enquiryId,
    isFromExternalPage,
    contactType,
    contactMethod,
    linkedSupplierName,
    linkedSupplierId,
    message,
    intent: intents,
    defaultIntentsSelected,
    defaultMessageTyped,
  },
});
